

import { IComingSoonProduct, IProduct } from './product.types';
import { PaginationInfo } from './search-filter.types';

export interface ApiResponse<T> {
  success: boolean;
  data: T;
  error?: string;
}

export interface ApiSearchResponse {
  success: boolean;
  data: IProduct[];
  pagination: PaginationInfo;
  error?: string;
}

export interface SearchApiResponse {
  success: boolean;
  data: IProduct[];
  comingSoonData: IComingSoonProduct[];
  pagination?: {
      currentPage: number;
      totalPages: number;
      totalCount: number;
      hasNextPage: boolean;
      hasPrevPage: boolean;
      limit: number;
  };
  searchQuery?: string;
  //eslint-disable-next-line
  appliedFilters?: Record<string, any>;
  error?: string;
}

export const CACHE_DURATION_MINUTES = 15;

export interface CachedData<T> {
  timestamp: number;
  data: T;
}

export interface BlobUploadOptions {
  access: 'public';
  addRandomSuffix?: boolean;
  cacheControlMaxAge?: number;
  contentType?: string;
}

export interface BlobUploadResult {
  url: string;
  pathname: string;
  size?: number;
}

export interface EmailOptions {
  to: string;
  subject: string;
  html: string;
}

export interface PasswordResetOptions {
  email: string;
  name: string;
  url: string; // The full reset URL with the token
}